/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import sizes from './sizes';

/**
 * An edit icon.
 * Used for editing tasting notes for example.
 *
 * @param {object} props
 * @param {string} [props.className]
 * @param {1 | 3 | 5} props.rating
 * @param {keyof sizes} [props.size] The icon size.
 */
export default function EditIcon({
  className,
  rating = 5,
  size = 'mediumLarge',
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // @ts-ignore
      sx={{
        width: sizes[size],
        height: sizes[size],
        verticalAlign: 'middle',
      }}
      className={className}
      viewBox="0 0 50 50"
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d={ratingPaths[rating] || ratingPaths.default}
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

const ratingPaths = {
  1: 'M25 50C11.193 50 0 38.807 0 25S11.193 0 25 0s25 11.193 25 25-11.193 25-25 25zm0-1.923c12.745 0 23.077-10.332 23.077-23.077C48.077 12.255 37.745 1.923 25 1.923 12.255 1.923 1.923 12.255 1.923 25c0 12.745 10.332 23.077 23.077 23.077zM16.575 36.9c0 .531.43.962.962.962h14.208a.962.962 0 000-1.923H17.537a.962.962 0 00-.962.961zm20.845-11.1a2.003 2.003 0 100-4.006 2.003 2.003 0 000 4.006zm-23.638-2.003a2.003 2.003 0 11-4.006 0 2.003 2.003 0 014.006 0z',
  3: 'M25 50C11.193 50 0 38.807 0 25S11.193 0 25 0s25 11.193 25 25-11.193 25-25 25zm0-1.923c12.745 0 23.077-10.332 23.077-23.077C48.077 12.255 37.745 1.923 25 1.923 12.255 1.923 1.923 12.255 1.923 25c0 12.745 10.332 23.077 23.077 23.077zm14.423-24.279a2.003 2.003 0 11-4.006 0 2.003 2.003 0 014.006 0zM11.78 25.801a2.003 2.003 0 100-4.006 2.003 2.003 0 000 4.006zM25.16 38.668c-3.183 0-6.252-.713-8.972-2.054a.961.961 0 11.85-1.725c2.456 1.21 5.233 1.856 8.122 1.856 2.987 0 5.854-.69 8.366-1.979a.962.962 0 11.878 1.711c-2.785 1.429-5.953 2.191-9.244 2.191z',
  5: 'M0 25c0 13.807 11.193 25 25 25s25-11.193 25-25S38.807 0 25 0 0 11.193 0 25zm48.077 0c0 12.745-10.332 23.077-23.077 23.077C12.255 48.077 1.923 37.745 1.923 25 1.923 12.255 12.255 1.923 25 1.923c12.745 0 23.077 10.332 23.077 23.077zm-10.657.801a2.003 2.003 0 100-4.006 2.003 2.003 0 000 4.006zm-23.638-2.003a2.003 2.003 0 11-4.006 0 2.003 2.003 0 014.006 0zm1.843 10.048a15.33 15.33 0 001.325 3.602c1.682 3.193 4.3 5.063 8.163 5.055 3.854-.008 6.424-1.88 8.037-5.07.58-1.146.99-2.382 1.256-3.619.035-.164.067-.324.096-.479-.687.059-1.438.117-2.237.171-2.371.163-4.732.266-6.941.28l-.16.001-.161.001h-.321a114.888 114.888 0 01-7.11-.252c-.73-.046-1.418-.096-2.048-.146.03.147.064.3.1.456zm2.07-2.229a129.782 129.782 0 01-3.225-.247.962.962 0 00-1.05 1.045c.037.39.137 1.043.333 1.874.326 1.379.813 2.759 1.495 4.055 1.993 3.783 5.225 6.092 9.87 6.082 4.641-.01 7.83-2.333 9.748-6.126a16.992 16.992 0 001.42-4.08c.18-.835.267-1.492.295-1.885a.962.962 0 00-1.056-1.024 130.664 130.664 0 01-3.391.277c-2.335.16-4.658.26-6.823.275l-.157.001h-.157l-.313.001c-2.22-.002-4.603-.095-6.989-.248z',
};
